module.exports = __webpack_public_path__ + "static/img/entry_top.8e381f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/entry_top.png
// module id = Kxfu
// module chunks = 1